/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProjectMemberRow__ProjectMembershipFragmentDoc } from './ProjectMember.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { CrmContactPersonFragmentDoc } from '../../auth/UserDataProvider.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WithProjectInfo_Project_Fragment = { __typename: 'Project', id: string, title: string, description: string, ticket: boolean, number: string, createdAt?: any | null, closedAt?: any | null, categories: Array<string>, type?: Types.ProjectType | null, owningSystemOrganisationId: string };

export type WithProjectInfo_Request_Fragment = { __typename: 'Request', id: string, title: string, description: string, ticket: boolean, number: string, createdAt?: any | null, closedAt?: any | null, categories: Array<string>, type: Types.ProjectType, owningSystemOrganisationId: string };

export type WithProjectInfoFragment = WithProjectInfo_Project_Fragment | WithProjectInfo_Request_Fragment;

export type ProjectTeam__TeamFragment = { __typename: 'Team', id: string, name: string, type: string, isActive: boolean };

export type ProjectOverview__ProjectFragment = { __typename: 'Project', id: string, type?: Types.ProjectType | null, projectChangedAt: any, title: string, number: string, description: string, categories: Array<string>, state: Types.ProjectStateMachineStatus, marketplace: boolean, ticket: boolean, urgent: boolean, status: Types.OpportunityStatus, deadline?: any | null, earliestStart?: any | null, viewerPermissions: Array<Types.PermissionName>, budget?: { __typename: 'Money', currency: string, amount: number } | null, author: { __typename: 'User', id: string, title: Types.Salutation, firstname: string, familyname: string }, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, permissionNames: Array<Types.PermissionName>, user: { __typename: 'User', id: string, email: any, organisationId: string, organisationTitle: string, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }> }>, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, contactType: Types.CrmOrganisationContactType, description: string, website: string, isMeister: boolean, email: any, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, locale: string, categories: Array<string>, phones: Array<{ __typename: 'Phone', id: string, number: string }> } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, members: Array<{ __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } | null, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }>, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> };

export type CreateProjectMutationVariables = Types.Exact<{
  input: Types.ProjectCreateInput;
}>;


export type CreateProjectMutation = { createProject: { __typename: 'ProjectCreateResult', project: { __typename: 'Project', id: string, type?: Types.ProjectType | null, projectChangedAt: any, title: string, number: string, description: string, categories: Array<string>, state: Types.ProjectStateMachineStatus, marketplace: boolean, ticket: boolean, urgent: boolean, status: Types.OpportunityStatus, deadline?: any | null, earliestStart?: any | null, viewerPermissions: Array<Types.PermissionName>, budget?: { __typename: 'Money', currency: string, amount: number } | null, author: { __typename: 'User', id: string, title: Types.Salutation, firstname: string, familyname: string }, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, permissionNames: Array<Types.PermissionName>, user: { __typename: 'User', id: string, email: any, organisationId: string, organisationTitle: string, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }> }>, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, contactType: Types.CrmOrganisationContactType, description: string, website: string, isMeister: boolean, email: any, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, locale: string, categories: Array<string>, phones: Array<{ __typename: 'Phone', id: string, number: string }> } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, members: Array<{ __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } | null, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }>, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> } } };

export type ModifyProjectMutationVariables = Types.Exact<{
  input: Types.ProjectModifyInput;
}>;


export type ModifyProjectMutation = { modifyProject: { __typename: 'ProjectModifyResult', project: { __typename: 'Project', id: string, type?: Types.ProjectType | null, projectChangedAt: any, title: string, number: string, description: string, categories: Array<string>, state: Types.ProjectStateMachineStatus, marketplace: boolean, ticket: boolean, urgent: boolean, status: Types.OpportunityStatus, deadline?: any | null, earliestStart?: any | null, viewerPermissions: Array<Types.PermissionName>, budget?: { __typename: 'Money', currency: string, amount: number } | null, author: { __typename: 'User', id: string, title: Types.Salutation, firstname: string, familyname: string }, internalStakeholders: Array<{ __typename: 'ProjectMembership', id: string, permissionNames: Array<Types.PermissionName>, user: { __typename: 'User', id: string, email: any, organisationId: string, organisationTitle: string, jobTitle: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, roles: Array<{ __typename: 'OrganisationRole', id: string, internalName: string, label: string }>, defaultProjectRoles: Array<{ __typename: 'ProjectRole', id: string, internalName: string, label: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }> }>, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, contactType: Types.CrmOrganisationContactType, description: string, website: string, isMeister: boolean, email: any, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPerson?: { __typename: 'CrmPerson', id: string, fullname: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, locale: string, categories: Array<string>, phones: Array<{ __typename: 'Phone', id: string, number: string }> } | null, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, members: Array<{ __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }> } | null, roles: Array<{ __typename: 'ProjectRole', id: string, label: string, internalName: string }>, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }>, attachments: Array<{ __typename: 'Attachment', id: string, title: string, mimeType: string, url: string, group: string }> } } };

export type AddProjectTeamMutationVariables = Types.Exact<{
  input: Types.AddProjectTeamInput;
}>;


export type AddProjectTeamMutation = { addProjectTeam: { __typename: 'AddProjectTeamResult', project: { __typename: 'Project', id: string, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }> } } };

export type RemoveProjectTeamMutationVariables = Types.Exact<{
  input: Types.RemoveProjectTeamInput;
}>;


export type RemoveProjectTeamMutation = { removeProjectTeam: { __typename: 'RemoveProjectTeamResult', project: { __typename: 'Project', id: string, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }> } } };

export type SetProjectTeamsMutationVariables = Types.Exact<{
  input: Types.SetProjectTeamsInput;
}>;


export type SetProjectTeamsMutation = { setProjectTeams: { __typename: 'SetProjectTeamsResult', project: { __typename: 'Project', id: string, teams: Array<{ __typename: 'Team', id: string, name: string, type: string, isActive: boolean }> } } };

export const WithProjectInfoFragmentDoc = gql`
    fragment WithProjectInfo on WithProjectInfo {
  id
  title
  description
  ticket
  number
  createdAt
  closedAt
  categories
  type
  owningSystemOrganisationId
}
    `;
export const ProjectTeam__TeamFragmentDoc = gql`
    fragment ProjectTeam__Team on Team {
  id
  name
  type
  isActive
}
    `;
export const ProjectOverview__ProjectFragmentDoc = gql`
    fragment ProjectOverview__Project on Project {
  id
  type
  projectChangedAt
  title
  number
  description
  categories
  state
  marketplace
  ticket
  urgent
  status
  deadline
  earliestStart
  budget {
    currency
    amount
  }
  author {
    id
    title
    firstname
    familyname
  }
  internalStakeholders {
    id
    ...ProjectMemberRow__ProjectMembership
  }
  crmOrganisation {
    id
    title
    billingAddress {
      ...AddressDetails__Address
    }
    branchAddress {
      ...AddressDetails__Address
    }
    contactType
    contactPerson {
      id
      fullname
      phones {
        id
        number
      }
    }
    description
    website
    isMeister
    contactPerson {
      id
      ...CrmContactPerson
    }
    email
    phones {
      id
      main
      type
      number
    }
    logo {
      ...AttachmentSnapshot
    }
    members {
      id
      title
      description
      website
      isMeister
      familyname
      firstname
      fullname
      locale
      email
      phones {
        id
        main
        type
        number
      }
      avatar {
        ...AttachmentSnapshot
      }
    }
  }
  roles {
    id
    label
    internalName
  }
  viewerPermissions
  teams {
    ...ProjectTeam__Team
  }
  ...Attachments
}
    ${ProjectMemberRow__ProjectMembershipFragmentDoc}
${AddressDetails__AddressFragmentDoc}
${CrmContactPersonFragmentDoc}
${AttachmentSnapshotFragmentDoc}
${ProjectTeam__TeamFragmentDoc}
${AttachmentsFragmentDoc}`;
export const CreateProjectDocument = gql`
    mutation CreateProject($input: ProjectCreateInput!) {
  createProject(input: $input) {
    project {
      id
      ...ProjectOverview__Project
    }
  }
}
    ${ProjectOverview__ProjectFragmentDoc}`;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const ModifyProjectDocument = gql`
    mutation ModifyProject($input: ProjectModifyInput!) {
  modifyProject(input: $input) {
    project {
      id
      ...ProjectOverview__Project
    }
  }
}
    ${ProjectOverview__ProjectFragmentDoc}`;
export type ModifyProjectMutationFn = Apollo.MutationFunction<ModifyProjectMutation, ModifyProjectMutationVariables>;

/**
 * __useModifyProjectMutation__
 *
 * To run a mutation, you first call `useModifyProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyProjectMutation, { data, loading, error }] = useModifyProjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyProjectMutation(baseOptions?: Apollo.MutationHookOptions<ModifyProjectMutation, ModifyProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyProjectMutation, ModifyProjectMutationVariables>(ModifyProjectDocument, options);
      }
export type ModifyProjectMutationHookResult = ReturnType<typeof useModifyProjectMutation>;
export type ModifyProjectMutationResult = Apollo.MutationResult<ModifyProjectMutation>;
export type ModifyProjectMutationOptions = Apollo.BaseMutationOptions<ModifyProjectMutation, ModifyProjectMutationVariables>;
export const AddProjectTeamDocument = gql`
    mutation AddProjectTeam($input: AddProjectTeamInput!) {
  addProjectTeam(input: $input) {
    ... on AddProjectTeamResult {
      project {
        id
        teams {
          ...ProjectTeam__Team
        }
      }
    }
  }
}
    ${ProjectTeam__TeamFragmentDoc}`;
export type AddProjectTeamMutationFn = Apollo.MutationFunction<AddProjectTeamMutation, AddProjectTeamMutationVariables>;

/**
 * __useAddProjectTeamMutation__
 *
 * To run a mutation, you first call `useAddProjectTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectTeamMutation, { data, loading, error }] = useAddProjectTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddProjectTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectTeamMutation, AddProjectTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectTeamMutation, AddProjectTeamMutationVariables>(AddProjectTeamDocument, options);
      }
export type AddProjectTeamMutationHookResult = ReturnType<typeof useAddProjectTeamMutation>;
export type AddProjectTeamMutationResult = Apollo.MutationResult<AddProjectTeamMutation>;
export type AddProjectTeamMutationOptions = Apollo.BaseMutationOptions<AddProjectTeamMutation, AddProjectTeamMutationVariables>;
export const RemoveProjectTeamDocument = gql`
    mutation RemoveProjectTeam($input: RemoveProjectTeamInput!) {
  removeProjectTeam(input: $input) {
    ... on RemoveProjectTeamResult {
      project {
        id
        teams {
          ...ProjectTeam__Team
        }
      }
    }
  }
}
    ${ProjectTeam__TeamFragmentDoc}`;
export type RemoveProjectTeamMutationFn = Apollo.MutationFunction<RemoveProjectTeamMutation, RemoveProjectTeamMutationVariables>;

/**
 * __useRemoveProjectTeamMutation__
 *
 * To run a mutation, you first call `useRemoveProjectTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectTeamMutation, { data, loading, error }] = useRemoveProjectTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveProjectTeamMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectTeamMutation, RemoveProjectTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectTeamMutation, RemoveProjectTeamMutationVariables>(RemoveProjectTeamDocument, options);
      }
export type RemoveProjectTeamMutationHookResult = ReturnType<typeof useRemoveProjectTeamMutation>;
export type RemoveProjectTeamMutationResult = Apollo.MutationResult<RemoveProjectTeamMutation>;
export type RemoveProjectTeamMutationOptions = Apollo.BaseMutationOptions<RemoveProjectTeamMutation, RemoveProjectTeamMutationVariables>;
export const SetProjectTeamsDocument = gql`
    mutation SetProjectTeams($input: SetProjectTeamsInput!) {
  setProjectTeams(input: $input) {
    ... on SetProjectTeamsResult {
      project {
        id
        teams {
          ...ProjectTeam__Team
        }
      }
    }
  }
}
    ${ProjectTeam__TeamFragmentDoc}`;
export type SetProjectTeamsMutationFn = Apollo.MutationFunction<SetProjectTeamsMutation, SetProjectTeamsMutationVariables>;

/**
 * __useSetProjectTeamsMutation__
 *
 * To run a mutation, you first call `useSetProjectTeamsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProjectTeamsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProjectTeamsMutation, { data, loading, error }] = useSetProjectTeamsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProjectTeamsMutation(baseOptions?: Apollo.MutationHookOptions<SetProjectTeamsMutation, SetProjectTeamsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProjectTeamsMutation, SetProjectTeamsMutationVariables>(SetProjectTeamsDocument, options);
      }
export type SetProjectTeamsMutationHookResult = ReturnType<typeof useSetProjectTeamsMutation>;
export type SetProjectTeamsMutationResult = Apollo.MutationResult<SetProjectTeamsMutation>;
export type SetProjectTeamsMutationOptions = Apollo.BaseMutationOptions<SetProjectTeamsMutation, SetProjectTeamsMutationVariables>;